import { useEffect } from 'react';
import { implementInstallerInHost, prefetchDataInternal, unmountCleanup } from './helperFunctions';
export const useInstallApp = essentials => {
  useEffect(() => unmountCleanup, []);
  return implementInstallerInHost(essentials);
};

/** @internal
 * do not use without permission from dev-center,
 * channel: #dev-center
 *  */
export const useInstallAppOneStepStandalone = _ref => {
  let {
    prefetchDataParams,
    ...params
  } = _ref;
  useEffect(() => unmountCleanup, []);
  useEffect(() => {
    prefetchDataParams && prefetchDataInternal({
      ...prefetchDataParams,
      isOneStepInstall: true
    });
  }, [prefetchDataParams]);
  return implementInstallerInHost({
    ...params,
    isOneStepInstall: true
  });
};
//# sourceMappingURL=useInstallApp.js.map